import { useState, useEffect } from "react";
// node.js library that concatenates classes (strings)


// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  Modal,
  Button
} from "reactstrap";

import { useHistory } from 'react-router-dom';
import moment from "moment";

import Header from "../../components/Headers/Header.js";

import helper from '../../services/helper.service';
import adminApi from '../../services/admin.service';
import session from '../../services/session.service';
import environments from "../../environments/index.js";
import EditClub from "../EditClub/index.js";

function  Dashboard(props){

  const history = useHistory();
  const [clubList, setClubList] = useState([]);
  const [isRead, setIsRead] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [clubAllList, setClubAllList] = useState([]);
  const [pageArray, setPageArray] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    console.log("clublist: ", clubList);
    if(!isRead){
      getClubList();
    }
   
  });

  const onYesDelete = (e) => {
    const selectedClub = clubList[global.deleteIndex];
    const clubId = selectedClub.clubId;
    console.log("clubId: ", clubId);

    adminApi.deleteClub({club_id: clubId})
      .then((response) => {

      console.log("delete reponse: ");
      console.log(response);

      if(response.status === 200){
          // helper.showToast('Success', 'Successfully deleted.', 1);
          window.location.reload();
          

      }else {
         
          helper.showToast('Error', 'Failed to delete.', 3);
      }
    })
    .catch((error) => {
        console.log("err: ", error);
        session.set('isLogin', false);
        helper.showToast('Error', 'Invalid auth', 3);
    })
  
  }

  const getClubList = () => {
    setIsRead(true)
    adminApi.getClubList({})
    .then((response) => {

    console.log("clublist reponse: ");
    console.log(response);

    if(response.status === 200){
        // helper.showToast('Success', 'Successfully get.', 1);
        // setClubList(response.data);
        let tempClubList = [];
        let tempItem;
        const clubData = response.data;
        for(let i = 0; i < clubData.length; i++){
          if(clubData[i].username !== 'admin'){

            let date = moment(clubData[i].created_at).format('l');

            let logoUrl = environments.domain + "storage/upload/images/" +clubData[i].logo_url;

            tempItem = {
              clubId: clubData[i].id,
              name: clubData[i].name,
              email: clubData[i].email,
              username: clubData[i].username,
              password: clubData[i].password,
              latitude: clubData[i].latitude,
              longitude: clubData[i].longitude,
              radius: clubData[i].radius,
              logoUrl: logoUrl,
              timezone: clubData[i].timezone,
              createdAt: date,
              turn: clubData[i].turn,
              heading: clubData[i].heading,
              lati_center: clubData[i].lati_center,
              long_center: clubData[i].long_center,
              radius_center: clubData[i].radius_center,
              map: clubData[i].map,
              group: clubData[i].group,
              some2: clubData[i].some2,
              some3: clubData[i].some3,
              tee_duration: clubData[i].tee_duration,
              tee_end: clubData[i].tee_end,
              tee_start: clubData[i].tee_start,
              map_marker_label: clubData[i].map_marker_label,
              has_27_holes: clubData[i].has_27_holes,
              name_of_course_a: clubData[i].name_of_course_a,
              name_of_course_b: clubData[i].name_of_course_b,
              name_of_course_c: clubData[i].name_of_course_c,
              facility_id: clubData[i].facility_id,
            }

            tempClubList.push(tempItem);
          }
        }

        const tempArray = [...tempClubList].sort((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        });

        // Sorted list (admin already excluded in tempArray). One row per index — do not
        // cross-check with clubData[i], which is unsorted and misaligned with tempArray.
        const tempSortedList = tempArray.map((row, i) => ({
          number: i + 1,
          ...row,
        }));

  

        setClubAllList(tempSortedList);

        configurePage(tempSortedList, currentPage);
      

        // window.location.reload();
        

        }else {
        
            helper.showToast('Error', 'Failed to get.', 3);
        }
    })
    .catch((error) => {
        console.log("err: ", error);
      
        helper.showToast('Error', 'Invalid auth', 3);
    })
  }

  const configurePage = (list, page) => {
    const listCount = 7;
    const startPage = (page -1 ) * listCount;
    let endPage = (page) * listCount;
    if(list.length < endPage){
      endPage = list.length;
    }
    console.log("start & end index: ", startPage, endPage);
    const pageCount = list.length / listCount;
    console.log("pageCount: ", list);

    let pageArray = [];
    for(let i = 0; i < pageCount; i++){
      let page = i + 1;
      pageArray.push(page);
    }

    setPageArray(pageArray);

    let clubData = list;
    let tempClubList = [];
    let tempItem;
    for(let i = startPage; i < endPage; i++){
      if (!clubData[i]) continue;
      const row = clubData[i];
      tempItem = {
        number: row.number,
        clubId: row.clubId,
        name: row.name,
        email: row.email,
        username: row.username,
        password: row.password,
        latitude: row.latitude,
        longitude: row.longitude,
        radius: row.radius,
        logoUrl: row.logoUrl,
        timezone: row.timezone,
        createdAt: row.createdAt,
        turn: row.turn,
        heading: row.heading,
        lati_center: row.lati_center,
        long_center: row.long_center,
        radius_center: row.radius_center,
        map: row.map,
        group: row.group,
        some2: row.some2,
        some3: row.some3,
        tee_duration: row.tee_duration,
        tee_end: row.tee_end,
        tee_start: row.tee_start,
        map_marker_label: row.map_marker_label,
        has_27_holes: row.has_27_holes,
        name_of_course_a: row.name_of_course_a,
        name_of_course_b: row.name_of_course_b,
        name_of_course_c: row.name_of_course_c,
        facility_id: row.facility_id,
      };
      tempClubList.push(tempItem);
    }
    console.log("tempClubList: ", tempClubList);
    setClubList(tempClubList);

  }

  const goAddClub = () => {
    history.push('/admin/addClub');
  };

  const deleteClub = (e) => {

    setAlertShow(true);

    const index = e.target.id;
    console.log("delete index: ", index);
    global.deleteIndex = index;
    

  }

  const editClub = (e) => {
    const index = e.target.id;
    const selectedClub = clubList[index];
    console.log("selectedClub: ", selectedClub);

    history.push('/admin/editclub', {club: selectedClub});
  }

  const goClubMembers = e => {
    const index = e.target.id;
    const selectedClub = clubList[index];

    history.push('/admin/club-members', {club: selectedClub});
  }

  const goDashboard = e => {
    const index = e.target.id;
    const selectedClub = clubList[index];
    console.log("selectedClub: ", selectedClub);

    history.push('/admin/dashboard', {club: selectedClub});
  }

  const onClickPage = (e) => {

    let target = e.target;
    console.log("tempPage: ", target.innerText);
    let tempPage = Number(target.innerText);
    configurePage(clubAllList, tempPage);
    setCurrentPage(tempPage);
  }

  return (
    <>

      <Modal
        className="modal-dialog-centered modal-danger"
        contentClassName="bg-gradient-danger"
        isOpen={alertShow}
        toggle={() => setAlertShow(true)}
      >
        <div className="modal-header">
          {/* <h6 className="modal-title" id="modal-title-notification">
            Your attention is required
          </h6> */}
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setAlertShow(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="ni ni-bell-55 ni-3x" />
            <h4 className="heading mt-2">ATTENTION!</h4>
            <div className="text-white">
            Do You Want to Delete This Club?
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button className="btn-white" color="default" type="button"  onClick={() => onYesDelete()}>
            Yes
          </Button>
          <Button
            className="text-white ml-auto"
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={() => setAlertShow(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
      <Header count = {clubAllList.length}/>
      <Container className="mt--7" fluid >
      {/* Page content */}
         <Row>
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0">
                
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="text-white mb-0">Club List</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="info"
                      onClick={() =>goAddClub()}
                      size="sm"
                    >
                    
                      Add Club
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <Table
                className="align-items-center table-dark table-flush"
                responsive
              >
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">ID</th>
                    {/* <th scope="col" /> */}
                    <th scope="col">Name</th>
                    <th scope="col">Latitude</th>
                    <th scope="col">Longitude</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Password</th>
                    <th scope="col">Timezone</th>
                    <th scope="col" style={{ whiteSpace: 'break-spaces'}}> {`Exist Turn?`}</th>
                    <th scope="col" style={{ whiteSpace: 'break-spaces'}}> Has 27 Holes?</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {
                    clubList.length > 0 ?
                      clubList.map((item, index) => 
                      
                          <tr key = {index.toString()}>
                          <th>
                            {item.number}
                          </th>
                          <td scope="row">
                            <Media className="align-items-center">
                              <a
                                className=" mr-4"
                              >
                                <img
                                  alt="..."
                                  src = {item.logoUrl}
                                  className="img-thumbnail"
                                  style={{width: "80px"}}
                                />
                              </a>
                             
                                <span className=" text-sm">
                                {item.name}
                                </span>
                           
                            </Media>
                          </td>

                          {/* <td>{item.name}</td> */}
                       
                          <td>{item.latitude}</td>
                          <td>{item.longitude}</td>
                          <td>{item.username}</td>
                          <td>{item.password}</td>
                          <td>{item.timezone}</td>
                          <td>{item.turn == "true" ? "Yes" : "No"}</td>
                          <td>{item.has_27_holes == "true" ? "Yes" : "No"}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem
                                  id={index}
                                  onClick={(e) => goDashboard(e)}
                                >
                                  Dashboard
                                </DropdownItem>
                                <DropdownItem
                                  id={index}
                                  onClick={(e) => goClubMembers(e)}
                                >
                                  Members
                                </DropdownItem>
                                <DropdownItem
                                  id={index}
                                  onClick={(e) => editClub(e)}
                                >
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                  id={index}
                                  onClick={(e) => deleteClub(e)}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                    
                      )

                      :

                      <></>
                    
                  }
             
                </tbody>
              </Table>
              <CardFooter className="bg-transparent border-0">
          
                <Pagination
                  className="pagination justify-content-end"
                  listClassName="pagination-sm"
                >
                  {
                    pageArray.length > 0 ?
                    pageArray.map((item, index) => 

                    item == currentPage ? 
                    <PaginationItem className= "active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(item)=>onClickPage(item)}
                        tabIndex={index}
                      >
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                    :
                    <PaginationItem>
                      <PaginationLink
                        href="#"
                        onClick={(index)=>onClickPage(index)}
                        tabIndex={index}
                      >
                  
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                    )
                    :
                    <></>
                  }

                </Pagination>
             
              </CardFooter>
            </Card>
          </div>
        </Row>
     
      </Container>
    </>
  );
};

export default Dashboard;